export type UIButtons =
    'homeButton' | 'supportButton' | 'logoutButton' | 'historyButton' | 'gameRulesButton' | 'fullscreenButton' | 'cashierButton' | 'soundCheckbox';
